import { makeAutoObservable } from 'mobx';
import { groupByFunction } from './utils/rxjs/groupByFunction';
import { buildWrapContextKey } from '../../components/forms/tradeplans/wrapExistingPosition/wrapTradePlanUtils';

export class WrapTradePlanStore {
  root;
  activeContextKey = '';
  activeRequestId = '';
  latestResponseByContext = {};
  requestStatusByContext = {};
  submitPendingRequestId = '';
  submitResult = null;

  constructor(root) {
    makeAutoObservable(this);
    this.root = root;
    this.initializeStreams();
  }

  initializeStreams = () => {
    groupByFunction(
      'messageType',
      'wrapTradePlanCandidates',
      this.root.websocketSubject
    ).subscribe((msg) => this.handleWrapCandidatesMessage(msg));

    groupByFunction(
      'messageType',
      'addWrappedTradePlanResult',
      this.root.websocketSubject
    ).subscribe((msg) => this.handleAddWrappedTradePlanResult(msg));
  };

  beginCandidatesRequest = ({ requestId, brokerage, accountNumber }) => {
    const contextKey = buildWrapContextKey({ brokerage, accountNumber });
    this.activeContextKey = contextKey;
    this.activeRequestId = requestId;
    this.requestStatusByContext[contextKey] = {
      loading: true,
      error: '',
      requestId,
    };
  };

  handleWrapCandidatesMessage = (msg) => {
    const contextKey = buildWrapContextKey({
      brokerage: msg?.brokerage,
      accountNumber: msg?.accountNumber,
    });

    this.latestResponseByContext[contextKey] = msg;

    const activeStatus = this.requestStatusByContext[contextKey] ?? {};
    const isStale = activeStatus.requestId && activeStatus.requestId !== msg.requestId;

    if (isStale) {
      return;
    }

    this.requestStatusByContext[contextKey] = {
      loading: false,
      error: msg.success ? '' : msg.errorMessage || 'Unable to load wrap candidates.',
      requestId: msg.requestId,
    };
  };

  get activeCandidates() {
    return this.latestResponseByContext[this.activeContextKey] ?? null;
  }

  get activeRequestStatus() {
    return (
      this.requestStatusByContext[this.activeContextKey] ?? {
        loading: false,
        error: '',
        requestId: '',
      }
    );
  }

  beginWrappedTradePlanSubmit = ({ requestId }) => {
    this.submitPendingRequestId = requestId;
    this.submitResult = null;
  };

  handleAddWrappedTradePlanResult = (msg) => {
    if (
      this.submitPendingRequestId &&
      msg?.requestId !== this.submitPendingRequestId
    ) {
      return;
    }

    this.submitPendingRequestId = '';
    this.submitResult = msg;
  };

  resetSubmitResult = () => {
    this.submitPendingRequestId = '';
    this.submitResult = null;
  };
}
